const constants = {
  imageUploadHeight: 'auto',
  GUARANTEED_FALL_OF_THE_HAMMER_TITLE: 'Kundenerwartung',
  GUARANTEED_FALL_OF_THE_HAMMER_TEXT: [

    'Die "Kundenerwartung" entspricht dem Mindestverkaufspreis, den der Verkäufer bei der Inseratserstellung festlegen muss. Verkäufer geben erfahrungsgemäß oft höhere Mindestverkaufspreise an, als sie tatsächlich erzielen möchten.',
    'Wird die Kundenerwartung durch Ihr Gebot erreicht oder übertroffen, erfolgt mit Auslauf der Auktion automatisch der Zuschlag zu Ihrem Höchstgebot (keine "Online-Nachverhandlung"). Liegt Ihr Höchstgebot nach Auktionsende unter der Kundenerwartung, können Sie als Höchstbietender mit dem Verkäufer online nachverhandeln und das Fahrzeug ggf. unter dem Kundenerwartungspreis bzw. zu Ihrem letzten Höchstgebot erwerben.'],

  TRAILER: 'trailer',
  MOTORHOME: 'motorhome',

  avatarSizeOnboardingSteps: 60,
  avatarSizeOnboardingStepsMobile: 45,

  onboardingStepperStatus: {
    VMM_VALUATED_AND_VMM_PRODUCT_EDITING: 'VMM_VALUATED_AND_VMM_PRODUCT_EDITING',
    VMM_UNDER_REVIEW_AND_VMM_PRODUCT_EDITING: 'VMM_UNDER_REVIEW_AND_VMM_PRODUCT_EDITING',
    VMM_EDITING_AND_VMM_PRODUCT_EDITING: 'VMM_EDITING_AND_VMM_PRODUCT_EDITING',
    PRODUCT_IN_EDITING: 'PRODUCT_IN_EDITING',
    PRODUCT_EXISTS_BUT_NOT_IN_EDITING_GO_TO_MY_ADS: 'PRODUCT_EXISTS_BUT_NOT_IN_EDITING_GO_TO_MY_ADS',
    ELSE: 'ELSE'
  },

  TP: {
    SOURCE: {
      MAIN_LP: 'main_lp',
      MY_ADS: 'my_ads',
      OTHER_LP: 'other_lp',
      SELL: 'sell'
    },
    FUNNEL: {
      VSTEPPER: 'vstepper',
      AD_INTAKE: 'ad_intake',
      VMM: 'vmm'
    }
  }

}

export default constants
